import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  authUser: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthUser(state, action) {
      state.authUser = action.payload;
    },
    clearAuthData(state) {
      state.authUser = null;
    },
  },
});

export const { setAuthUser, clearAuthData } = authSlice.actions;
export default authSlice;
